import { CandidateStages } from 'components/styled/icon/candidate-stage/stage-icon'

const getStageType = type => {
  switch (type) {
    case 'custom':
    case 'calendar':
    case 'videointerview':
      return CandidateStages.Custom
    case 'hired':
      return CandidateStages.Hired
    case 'withdrawn':
      return CandidateStages.Withdrawn
    case 'rejected':
      return CandidateStages.Rejected
    case 'proceed':
      return CandidateStages.Proceed
    case 'personalinterview':
      return CandidateStages.PersonalInterview
    default:
      return CandidateStages.New
  }
}

export const getStageTypeAndCustomStage = (stage, stageItems, stageKeys) => {
  const customStageType =
    stage.type === 'custom' ||
    stage.type === 'videointerview' ||
    stage.type === 'calendar'
  const name = stageKeys[stage.name] || stage.name
  const stageType = getStageType(stage.type)
  const stageIndex =
    stageItems && stageItems.findIndex(s => s._id === stage._id)
  const videoInterviewName = `${
    stageKeys.videointerviewed
  }: ${stage.name.substring(15)}`

  const customStage = customStageType
    ? {
        name: stage.type === 'videointerview' ? videoInterviewName : name,
        currStageNum: stageIndex + 1,
        numOfStages: stageItems && stageItems.length,
      }
    : undefined

  return { stageType, customStage }
}
